import { NotificationType, NotificationTypes } from '../types/notifications';

// Keep in sync with api
export const EMPLOYEE_NOTIFICATIONS = [
  NotificationTypes.CHAT_MESSAGE,
  NotificationTypes.APPOINTMENT_REQUESTED,
  NotificationTypes.APPOINTMENT_SCHEDULED,
  NotificationTypes.APPOINTMENT_CONFIRMED,
  NotificationTypes.APPOINTMENT_RESCHEDULED,
  NotificationTypes.APPOINTMENT_CANCELED,
  NotificationTypes.APPOINTMENT_REMINDER,
  NotificationTypes.PAYMENT_RECEIVED,
  NotificationTypes.QUEUE_APPOINTMENT_ASSIGNED,
  NotificationTypes.APPOINTMENT_OFFERED_TIMES_DECLINED,
];

// Keep in sync with api
export const MANAGER_NOTIFICATIONS = [
  NotificationTypes.MANAGER_NEW_REQUEST,
  NotificationTypes.MANAGER_NEW_GENERAL_REQUEST,
  NotificationTypes.MANAGER_APPOINTMENT_SCHEDULED,
  NotificationTypes.MANAGER_APPOINTMENT_CANCELED,
  NotificationTypes.MANAGER_JOIN_REQUEST,
];

// Notifications only available to team managers: (canManageTeam || canViewReports) && isUserAdminOrManager
export const TEAM_MANAGER_NOTIFICATIONS: NotificationType[] = [
  NotificationTypes.MANAGER_JOIN_REQUEST,
];

// Keep in sync with api
export const NO_SMS_NOTIFICATIONS: NotificationType[] = [];

// Keep in sync with api
export const NO_PUSH_NOTIFICATIONS: NotificationType[] = [
  ...MANAGER_NOTIFICATIONS,
];

// Keep in sync with api
export const NO_EMAIL_NOTIFICATIONS: NotificationType[] = [
  NotificationTypes.QUEUE_APPOINTMENT_ASSIGNED,
  NotificationTypes.APPOINTMENT_OFFERED_TIMES_DECLINED,
];

export const NOTIFICATION_DETAILS = {
  [NotificationTypes.CHAT_MESSAGE]: {
    label: 'Chat Messages',
    description: 'Never miss important messages from your clients',
  },
  [NotificationTypes.APPOINTMENT_REQUESTED]: {
    label: 'Appointment Requests',
    description: 'Stay updated when new appointments are requested',
  },
  [NotificationTypes.APPOINTMENT_SCHEDULED]: {
    label: 'Appointment Scheduled',
    description: 'Stay updated when appointments are added to your calendar',
  },
  [NotificationTypes.APPOINTMENT_CONFIRMED]: {
    label: 'Appointment Confirmed',
    description: 'Stay updated when appointments are confirmed',
  },
  [NotificationTypes.APPOINTMENT_RESCHEDULED]: {
    label: 'Appointment Rescheduled',
    description: 'Stay updated when appointments are rescheduled',
  },
  [NotificationTypes.APPOINTMENT_CANCELED]: {
    label: 'Appointment Canceled',
    description: 'Stay updated when appointments are canceled',
  },
  [NotificationTypes.APPOINTMENT_REMINDER]: {
    label: 'Appointment Reminders',
    description:
      'Never miss important reminders about your upcoming appointments',
  },
  [NotificationTypes.APPOINTMENT_OFFERED_TIMES_DECLINED]: {
    label: 'Offered Times Declined',
    description:
      "Know when a client can't make any of the times you offered them",
  },
  [NotificationTypes.PAYMENT_RECEIVED]: {
    label: 'Checkout Processed',
    description: 'Stay updated when appointment checkouts are processed',
  },
  [NotificationTypes.QUEUE_APPOINTMENT_ASSIGNED]: {
    label: 'Walk-in Assigned',
    description: 'Stay updated when a walk-in appointment is assigned to you',
  },
  [NotificationTypes.MANAGER_NEW_REQUEST]: {
    label: 'New Request',
    description: 'Stay updated when new requests are received',
  },
  [NotificationTypes.MANAGER_NEW_GENERAL_REQUEST]: {
    label: 'New General Request',
    description: 'Stay updated when new general requests are received',
  },
  [NotificationTypes.MANAGER_APPOINTMENT_SCHEDULED]: {
    label: 'Appointment Scheduled',
    description:
      "Stay updated when appointments are added to employees' calendars",
  },
  [NotificationTypes.MANAGER_APPOINTMENT_CANCELED]: {
    label: 'Appointment Canceled',
    description: 'Stay updated when appointments are canceled',
  },
  [NotificationTypes.MANAGER_JOIN_REQUEST]: {
    label: 'Request to Join',
    description: 'Stay updated when an artist requests to join your studio',
  },
  [NotificationTypes.EMPLOYEE_JOIN_REQUEST_APPROVED]: {
    label: 'Join Request Approved',
    description: 'Stay updated when your request to join a studio is approved',
  },
  [NotificationTypes.EMPLOYEE_JOIN_REQUEST_REJECTED]: {
    label: 'Join Request Declined',
    description: 'Stay updated when your request to join a studio is declined',
  },
};
